"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateProductList = void 0;
var _globalApiClientReact = require("@ori/global-api-client-react");
var _utils = require("../utils");
/* istanbul ignore file -- api */

const updateProductList = async ({
  client,
  customerId,
  description,
  id,
  name,
  productCodes,
  type
}) => {
  const {
    data: list
  } = await (0, _globalApiClientReact.updateCustomerProductListTypeProductList)(client, customerId, type, id, {
    items: (0, _utils.mapListToApiObject)(productCodes),
    productListId: id,
    description,
    name
  });
  const {
    productListId
  } = list;
  if (!productListId) {
    return null;
  }
  return (0, _utils.mapGlobalApiProductListToList)({
    list: {
      ...list,
      productListId
    },
    type
  });
};
exports.updateProductList = updateProductList;
//# sourceMappingURL=updateProductList.js.map